import React from 'react';
import { useMediaQuery } from '@mui/material';
import GlobalPopUp from './globalPopUp';
import VoiceAIInboundPopup from '../../pages/ruleBasedInbox/threadView/components/voiceAI/voiceAIInboundPopup';
import VoiceCallSlideTransition from './voiceCallSlideTransition';
import { useVoiceCallStore } from '../../store/voiceCallStore';
import styles from '../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss';
import { useShallow } from 'zustand/react/shallow';

const GlobalInboundCallPopup = () => {
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    const { flagVoiceCallInboundPopup, setVoiceCallId, clearInboundCallState } = useVoiceCallStore(useShallow((state) => ({
        flagVoiceCallInboundPopup: state.flagVoiceCallInboundPopup,
        setVoiceCallId: state.setVoiceCallId,
        clearInboundCallState: state.clearInboundCallState
    })));

    const handleCloseInboundCallPopup = () => {
        setVoiceCallId('');
        clearInboundCallState();
    };

    return (
        <GlobalPopUp
            open={flagVoiceCallInboundPopup}
            handleClose={handleCloseInboundCallPopup}
            onClose={handleCloseInboundCallPopup}
            flagShowCloseIcon={false}
            flagBackdrop
            titlePadding="0px"
            paperMinWidth={flagSmallScreen ? '310px' : '440px'}
            paperMaxwidth={flagSmallScreen ? '440px' : '440px'}
            borderRadius="20px"
            className={styles.inboundCallDialog}
            TransitionComponent={VoiceCallSlideTransition}
            TransitionProps={{ appear: true }}
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(15, 23, 42, 0.72)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                },
            }}
            PaperProps={{
                className: styles.inboundCallDialogPaper,
            }}
        >
            <VoiceAIInboundPopup />
        </GlobalPopUp>
    );
};

export default GlobalInboundCallPopup;
